
import Wallet from "../../../assets/outline/Wallet.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WalletIcon({ className, dataTestid = "WalletIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Wallet data-testid={dataTestid} className={classes} {...rest} />
  );
}
